var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"legal-consulting-services"},[_c('img',{attrs:{"src":"https://tokencloud-test.oss-cn-beijing.aliyuncs.com/static/tc-anti-fraud/20260604-134517.jpg","alt":"services"}})])
}]

export { render, staticRenderFns }